import React from "react";
import { connect } from "react-redux";
import * as catalogActions from "../../../Home/actions/catalogs";
import { MaintenanceSelector } from "../../components/MaintenanceSelector";
import { Maintenance } from "../../../types-business/Products";
import { handleRequestError } from "../../../utils/helpers";

interface Props {
  getMaintenancesByMembership: (membresiaId: string) => void;
  getMaintenances: () => any;
  membershipId: string;
  clubId: string;
  loading: boolean;
  maintenances: Maintenance[];
  disabled: boolean;
  onChange: (value: string) => any;
  value: string;
  quotationUse: string;
  partner: any;
}

const getMaintenance = (maintenaces: any, maintenanceId: any) => {
  return maintenaces.find(
    ({ datosBasicosMantenimientoId }) =>
      datosBasicosMantenimientoId == maintenanceId
  );
};

class MaintenanceSelectorContainer extends React.Component<Props> {
  state = {
    maintenances: []
  };

  componentDidMount() {
    this.loadMaintenances(this.props.membershipId, this.props.clubId);
  }

  componentDidUpdate({ membershipId: prevMembershipId, clubId: prevClubId }) {
    const { membershipId, clubId } = this.props;
    if (prevMembershipId != membershipId || prevClubId != clubId) {
      this.loadMaintenances(membershipId, clubId);
    }
  }

  loadMaintenances = (membershipId, clubId) => {
    if (!this.props.disabled) {
      if (membershipId) {
        const { quotationUse } = this.props;
        catalogActions
          .getMaintenancesByMembershipForQuotation(
            membershipId,
            clubId,
            this.props.quotationUse == "RECOTIZACION" ? "VENTA" : quotationUse
          )
          .then(({ data }) => {
            /* 
            //// REQ 20250819 - Quitar de la lista el mantenimiento de la membresía en curso
            if (
              this.props.quotationUse == "REACTIVACION" &&
              !!this.props.partner
            ) {
              const {
                idMantenimiento,
                nombreMantenimiento
              } = this.props.partner;
              const mntexist = (data || []).find(
                x => x.datosBasicosMantenimientoId == idMantenimiento
              );
              if (!mntexist) {
                data.unshift({
                  datosBasicosMantenimientoId: idMantenimiento,
                  nombre: nombreMantenimiento
                });
              }
            } */

            this.setState({ maintenances: data });
          })
          .catch(handleRequestError);
      } else {
        this.setState({ maintenances: null });
        this.props.getMaintenances();
      }
    }
  };

  getMaintenaces = () => {
    if (!!this.state.maintenances && !!this.state.maintenances.length) {
      return [...this.state.maintenances];
    } else if (!!this.props.maintenances && !!this.props.maintenances.length) {
      return [...this.state.maintenances];
    } else {
      return [];
    }
  };

  render() {
    return (
      <MaintenanceSelector
        value={this.props.value}
        maintenances={this.getMaintenaces()}
        onChange={value => {
          const maintenanceObject = getMaintenance(
            this.getMaintenaces(),
            value
          );
          this.props.onChange(maintenanceObject);
        }}
        disabled={this.props.loading || this.props.disabled}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getMaintenancesByMembership: (membresiaId: string) => {
    dispatch(catalogActions.getMaintenancesByMembershipId(membresiaId));
  },
  getMaintenances: () => {
    dispatch(catalogActions.getMaintenances());
  }
});

const mapStateToProps = state => {
  const {
    catalogs: { maintenances, gettingMaintenances }
  } = state;

  return {
    maintenances,
    loading: gettingMaintenances
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceSelectorContainer);
